module.exports = __webpack_public_path__ + "static/media/pin.6209a796.svg";